import cn from 'classnames';
import styles from './ModalContentWrapper.module.scss';
import { ReactNode } from 'react';

type ModalContentWrapperProps = {
  className?: string;
  title?: string;
  description?: string;
  children: ReactNode;
  onClose?: () => void;
  showCloseButton?: boolean;
};

export function ModalContentWrapper({
  className,
  title,
  description,
  children,
  onClose,
  showCloseButton = true,
}: ModalContentWrapperProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <div className={styles.heading}>
        <div className={styles.header}>
          {title && <span className={styles.title}>{title}</span>}
          {!title && showCloseButton && <div />}
          {showCloseButton && (
            <img
              src="/svg/close-gray.svg"
              alt="close"
              className={styles.close}
              onClick={onClose}
            />
          )}
        </div>
        {description && (
          <span className={styles.description}>{description}</span>
        )}
      </div>
      {children}
    </div>
  );
}
